import { STIMULI_ACTION as ACTION_TYPE } from '../types/actionTypes';
import { getPropertyFromPayload } from '../lib';
const getActionTypeKey = actionType => {
  switch (actionType) {
    case ACTION_TYPE.SET_STIMULI:
      {
        return 'stimuli';
      }
    case ACTION_TYPE.SET_MULTIPLE:
      {
        return 'multiple';
      }
  }
  return '';
};
const reducer = (state, action) => {
  const {
    type,
    payload
  } = action;
  const k = getActionTypeKey(type);
  switch (k) {
    case 'multiple':
      {
        return Object.assign(Object.assign({}, state), payload);
      }
    case '':
      {
        throw new Error(`Unknown action: ${type}`);
      }
    default:
      {
        if (getPropertyFromPayload(k, payload) === undefined) {
          break;
        }
        return Object.assign(Object.assign({}, state), {
          [k]: getPropertyFromPayload(k, payload)
        });
      }
  }
  throw new Error('Error with payload provided');
};
export default reducer;